// @ts-strict-ignore
import { createContext } from "react";

import type { PusherContextV2Value } from "@lib/pusher";

export const PusherContextV2 = createContext<PusherContextV2Value>({
  subscribeChannel: undefined,
  unsubscribeChannel: undefined,
});
